import angular from 'angular'
import template from './template.html'

function NominasFondoreservaExportarComponent($dialogParams, dialog, $export) {
  let $ctrl = this,
    data = $dialogParams['data'];

  $ctrl.cancelar = cancelar;
  $ctrl.exportar = exportar;
  $ctrl.options = {
    filename: data['ID_Nomina'] + ' - Fondo de Reserva-Reserve Found - ' + data['Fecha_Final'].toYMD().replace(/-/g, ''),
  };

  function cancelar() {
    dialog.reject();
  }

  function exportar() {
    let pages = [{
      name: 'Fondo de Reserva',
      details: [
        {label: 'Empresa: ' + data.Empresa, cell: 'D1'},
        {label: 'Nomina: ' + data.ID_Nomina, cell: 'D2'},
        {label: 'Moneda: ' + data.Moneda, cell: 'D3'},
        // {label: "Departamento: " + Departamento, cell: "D4"},
        {label: 'Fecha: ' + data.Fecha.toYMD(), cell: 'I1'},
        {label: 'Fecha inicial: ' + data.Fecha_Inicial.toYMD(), cell: 'I2'},
        {label: 'Fecha final: ' + data.Fecha_Final.toYMD(), cell: 'I3'},
        {label: 'Fecha de pago: ' + data.Fecha_Pago.toYMD(), cell: 'I4'},
      ],
      columns: [
        {label: 'Emp.', format: {align: 'center', width: 4}},
        {label: 'Empleado', format: {align: 'center', width: 7}},
        {label: 'Nombre', format: {width: 40}},
        {label: 'Sala', format: {width: 20}},
        {label: 'Folio', format: {width: 10}},
        {label: 'Fecha', format: {type: 'date', width: 10}},
        {label: 'Cn.', format: {align: 'center', width: 5}},
        {label: 'Importe', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
        {label: 'Notas', format: {width: 50}},
      ],
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'E8',
      },
      data: data.Servicios.map(function (item) {
        return [
          item.ID_Empresa,
          item.ID_Empleado,
          item.Empleado,
          item.Sala,
          item.Folio,
          item.Fecha_Movimiento.toYMD(),
          '15',
          item.Importe,
          item.Notas,
        ];
      }),
    }];

    $export.excel($ctrl.options.filename, pages);
    dialog.resolve();
  }
}

angular.module('nominas.fondoreserva')
  .controller('NominasFondoreservaExportar', NominasFondoreservaExportarComponent)
  .config(($dialogProvider) => {
    $dialogProvider.dialog('nominas.fondoReserva.export', {
      controller: 'NominasFondoreservaExportar',
      template: template,
      controllerAs: '$ctrl',
    });
  });



// WEBPACK FOOTER //
// ./src/nominas/fondoreserva/components/exportar/component.js